<h1 ev-dialog-title data-testid="vc-error-title-text">{{ languageService.languageJSON?.Global_Alert || 'Alert' }}</h1>

<div ev-dialog-content class="scrollable" data-testid="vc-error-container">
  <div class="voice-error-content">
    <img class="voice-error-icon" alt=""
      [src]="'assets/icons/' + settingsService.getMap().Skin + '/voicecommand/not_available.svg'" />

    <app-modal-option-panel>
      <p class="voice-error-message" data-testid="vc-error-message-text" [ngClass]="{'long-msg': errorMsg.length > 30}">{{ errorMsg }}</p>
    </app-modal-option-panel>
  </div>
</div>

@if (notSupported) {
  <div ev-dialog-actions>
    <button class="ev-button primary" type="button" (click)="close()" data-testid="vc-error-ok-btn">
      {{ languageService.languageJSON?.Global_Ok || 'Ok' }}
    </button>
  </div>
}
